// @core/api/endpoints/payment/get_payment_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPaymentProviderResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get payment provider by ID
 * Retrieves a payment provider configuration with current health metrics and circuit breaker state.
 */
export async function GetPaymentProvider(
  id: string,
  options?: RequestOptions
): Promise<GetPaymentProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-providers/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetPaymentProviderResponse>(requestPath, { ...requestOptions });
}
